/**
 * @typedef {Object} RoutesState An index of routes by ID
 */

import { Route } from '../../entities'
import { REMOVE_FAVORITE, UPDATE_ROUTE, ADD_FAVORITE } from './actions'

/**
 * Updates the state according to a dispatched action.
 * @param {RoutesState} state Current state
 * @param {Object} action Handled action
 * @returns {RoutesState} New state object
 */
export default function routesReducer(state = {}, action) {
    switch (action.type) {
        case ADD_FAVORITE:
            state[action.routeId] = Route.copy(state[action.routeId])
            state[action.routeId].favor()
            return { ...state }

        case REMOVE_FAVORITE:
            state[action.routeId] = Route.copy(state[action.routeId])
            state[action.routeId].unfavor()
            return { ...state }

        case UPDATE_ROUTE:
            return {
                ...state,
                [action.route.id]: action.route,
            }

        default:
            return state
    }
}
